export const ACTIVE = { 
	value: "ACTIVE",
	key: "admin.users.menrolStatuses.active"
};
export const INACTIVE = {
	value: "INACTIVE",
	key: "admin.users.menrolStatuses.inactive",
};
export const NONEXISTENT = {
	value: "NONEXISTENT",
	key: "admin.users.menrolStatuses.nonexistent",
};

export default [NONEXISTENT, INACTIVE, ACTIVE];



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/users/enum/menrolStatusTypes.js